module.exports = __webpack_public_path__ + "static/media/LogoHeads_Gray.fd452b40.png";